let map;

const provinces = {
  "ChIJI9kl2-8udTERFHIryt1Uz0s": 22,	// Ho Chi Minh City
  "ChIJoVmP1vLDdjERjsI0345CNyc": 6,	// Bình Thuận
  "ChIJIY5foglSoDERTgqWSmqWc9Y": 6,	// Soc Trang
  "ChIJj-0MGk4XoDERE4o57BhuS7c": 5,	// Tra Vinh
  "ChIJeSj5jmq2dDERcxSNHInanzM": 5,	// Binh Duong
  "ChIJs2mi7ZHyoDER5dn-Lulyo3k": 5,	// Hau Giang
  "ChIJez-heqBJoTERs-aysVPn-a8": 7,	// Ca Mau
  "ChIJDb3qxxupmDERT8bH4BD4NO8": 4,	// Bac Lieu
  "ChIJzXUakhzaCTERevNfMyZB54c": 9,	// Kien Giang
  "ChIJn6e8DFyoCjERQ3UxZ-VUPKo": 1,	// Ben Tre
  "ChIJjSriTooZCjERuojAUiywHNw": 11,	// An Giang
  "ChIJfdvzWSYTcTERbPVUX9_SWrs": 14,	// Lam Dong
  "ChIJeUgqlTy2CjERI0HFz5nt6ts": 0,	// Long An
  "ChIJMXJO1JFCCzERzWzchde8giQ": 3,	// Tây Ninh
  "ChIJE45EIbybCjERpXVcaT5qxlI": 4,	// Vinh Long
  "ChIJHxIM1bNlCjERQG40rV7JoNw": 11,	// Dong Thap
  "ChIJQ44uKJxsdTERUu3qQZlT48w": 2,	// Ba Ria - Vung Tau
  "ChIJJepKuFLZdDERVRZuS_HmSuA": 3,	// Dong Nai
  "ChIJgSaoteuvCjERdWM3wQen4zw": 5,	// Tien Giang
  "ChIJzYJzkp9ioDERZ-wJEdljpHI": 8,	// Cần Thơ
  "ChIJ8_vR4A4fLTER9A7fYoWMcUg": 0,	// Dien Bien
  "ChIJUbTROSwyLTERLjxIkWCRKeI": 0,	// Lai Chau
  "ChIJBw5Mv4w7zTYRaJBG-7m2oiE": 0,	// Lao Cai
  "ChIJbyVFtz5UtTYRWm6Chdo0Pfo": 0,	// Lạng Sơn
  "ChIJ4R5JpfutNDERf3iEknEBVH8": 0,	// Tuyên Quang
  "ChIJTeuFSkjgyjYR0G5JK0iQA78": 0,	// Bắc Kạn
  "ChIJsXHT6sp5zDYRqIDLmrB4SIM": 0,	// Hà Giang
  "ChIJ52dYYbZcyjYRWFR2N_RyN2U": 0,	// Cao Bang
  "ChIJ1R093JBZMjERezgPalpkLVg": 0,	// Son La
  "ChIJGStwEvU5MzERteIKRp__AAU": 0,	// Yên Bái
  "ChIJd3qgchjENDERW0_vaRA3qVc": 0,	// Thai Nguyen
  "ChIJKfEdqqvkQDERKE3VIOD6ceQ": 0,	// Quảng Trị
  "ChIJ_65MY79wbzERgBoXHBy-bv4": 3,	// Phú Yên
  "ChIJ-zyQ3XmDNDERbmTIyOCN7DA": 0,	// Phú Thọ
  "ChIJcwkWqew-aDERse05Mm6NoU0": 3,	// Quang Ngai
  "ChIJwcgQb6twNjERLQwTPE5T5W0": 0,	// Ninh Bình
  "ChIJmZJ2447GNjERT_urFvXeeAE": 0,	// Thanh Hoa
  "ChIJXSYdMDWvNTERgtTWzxbqqac": 0,	// Hung Yen
  "ChIJLW8pOPawODERj1kjYi6HH5A": 0,	// Quảng Bình
  "ChIJ95BkcoecQTERtYTL98oPHKs": 7,	// Thua Thien Hue
  "ChIJM3A59dPkNTERx1sdOPgF5Go": 0,	// Thai Binh
  "ChIJL4V4mtcBSzERaoal8PR5B-0": 0,	// Quảng Ninh
  "ChIJJ6lE5uy1czERrYej9DDhMHU": 2,	// Dak Nong
  "ChIJKQqAE44ANTERDbkQYkF-mAI": 4,	// Ha Noi
  "ChIJUXqvJl0KNTERcI9VxsAgWeU": 0,	// Bac Ninh
  "ChIJvxtxbu8tbzERN_3lOgRMv0U": 4,	// Binh Dinh
  "ChIJrwn6F26VcDERRZ6Odp6S9fg": 4,	// Ninh Thuận
  "ChIJo4EvAoIfbDERDbVDgfa1Uow": 2,	// Gia Lai
  "ChIJb9jgnBgUNDERF_4UZiqEJag": 0,	// Hoa Binh
  "ChIJ4WQZGBHFNTERUmgyOw25qXQ": 0,	// Hà Nam
  "ChIJ7c9Gs6kQNTERyFDrUFtMQjw": 0,	// Bac Giang
  "ChIJV3Ew99r3cTERFTOI2ZR2-Y4": 2,	// Dak Lak
  "ChIJ3xtSUSEMNjERYt8l_r-i68g": 1,	// Nam Dinh
  "ChIJx8Pp7qEoODERaxB9uCZ7xxo": 0,	// Ha Tinh
  "ChIJrR1aC2TOOTERGaUZ13y_YVw": 0,	// Nghe An
  "ChIJJzcV2WViSjERPPfF4sM-Mpk": 0,	// Hai Phong
  "ChIJldPcqIwbcDERzggjMicIwmk": 9,	// Khánh Hòa
  "ChIJezo14dQNQjEReXZ0ZrGrnOQ": 3,	// Quảng Nam
  "ChIJuy3qgk3lNDERXxAb4T-O0MA": 0,	// Vĩnh Phúc
  "ChIJNVLgSPR6SjERU5AdBNFX6YI": 0,	// Hai Duong
  "ChIJ39GqWCPnazERVIrYzKoRm2E": 2,	// Kon Tum
  "ChIJEyolkscZQjERBn5yhkvL8B0": 5,	// Da Nang
  "ChIJHyJ92y9oczEREUL4cg4bwJQ": 2,	// Binh Phuoc
};

const post_offices = [
  [
    "AN GIANG",
    "BƯU CỤC BX CHÂU ĐỐC",
    "QL91, Vĩnh Mỹ, Châu Đốc, Châu Phú B, TP.Châu Đốc",
    10.6948897,
    105.1342876,
    1
  ],
  [
    "AN GIANG",
    "BƯU CỤC BX LONG XUYÊN",
    "392 Phạm Cự Lượng, P.Mỹ Quý, TP.Long Xuyên",
    10.3590362,
    105.4242561,
    1
  ],
  [
    "AN GIANG",
    "BƯU CỤC CÁI DẦU",
    "Số 73, tổ 5, ấp Bình Chánh, xã Bình Long, huyện Châu Phú, tỉnh An Giang",
    10.5658076,
    105.2466482,
    1
  ],
  [
    "AN GIANG",
    "BƯU CỤC CHỢ CHÂU ĐỐC",
    "66 Đ.Nguyễn Hữu Cảnh - Khóm 5 - P.Châu Phú A - Tp.Châu Đốc - Tỉnh An Giang.",
    10.7097702,
    105.1181293,
    1
  ],
  [
    "BÀ RỊA VŨNG TÀU",
    "BƯU CỤC 186 XÔ VIẾT NGHỆ TĨNH",
    "186 Xô Viết Nghệ Tĩnh, P. Thắng Tam",
    10.350773,
    107.0841203,
    1
  ],
  [
    "BÀ RỊA VŨNG TÀU",
    "BƯU CỤC BÀ RỊA",
    "QL51, Tổ 10, KP2, P.Phước Trung, TP.Bà Rịa",
    10.4907881,
    107.165575,
    1
  ],
  [
    "BẠC LIÊU",
    "BƯU CỤC BẠC LIÊU",
    "Bến xe Bạc Liêu, Đường Trần Phú, Quốc lộ 1A, Khóm 2, Phường 7, Thành Phố Bạc Liêu, Tỉnh Bạc Liêu",
    9.3029078,
    105.7177586,
    1
  ],
  [
    "BẠC LIÊU",
    "BƯU CỤC HÒA BÌNH - BẠC LIÊU",
    "617 QL 1A, TT Hòa Bình, Huyện Hòa Bình, Tỉnh Bạc Liêu",
    9.2800511,
    105.6179127,
    1
  ],
  [
    "BẠC LIÊU",
    "BƯU CỤC HỘ PHÒNG - BẠC LIÊU",
    "Quốc lộ1A, Ấp 1, Thị Trấn Hộ Phòng, Huyện Giá Rai, Tỉnh Bạc Liêu",
    9.2358945,
    105.4127109,
    1
  ],
  [
    "BẾN TRE",
    "BƯU CỤC BẾN TRE",
    "Võ Nguyên Giáp, Ấp 1, X.Sơn Đông, TP.Bến Tre",
    10.2551962,
    106.3563806,
    1
  ],
  [
    "BÌNH DƯƠNG",
    "BƯU CỤC BẾN CÁT - BÌNH DƯƠNG",
    "213 Đường D11, Phường Thới Hoà, Thị Xã Bến Cát, Bình Dương",
    11.1246597,
    106.5993749,
    1
  ],
  [
    "BÌNH DƯƠNG",
    "BƯU CỤC BẾN XE BÌNH DƯƠNG",
    "Đường 30/04, Phường Chánh Nghĩa, TP. Thủ Dầu Một, Tỉnh Bình Dương",
    10.9663794,
    106.5919233,
    1
  ],
  [
    "BÌNH DƯƠNG",
    "BƯU CỤC BÌNH DƯƠNG",
    "110  Huỳnh Văn Lũy, Phường Phú Lợi, Thủ Dầu Một, Bình Dương",
    10.9891379,
    106.6703572,
    1
  ],
  [
    "BÌNH DƯƠNG",
    "BƯU CỤC DĨ AN - BÌNH DƯƠNG",
    "269 Đường Lê Hồng Phong, Khu phố Đông Chiêu, Phường Tân Đông Hiệp, TP Dĩ An, Tỉnh Bình Dương",
    10.9235311,
    106.7244576,
    1
  ],
  [
    "BÌNH DƯƠNG",
    "BƯU CỤC LÁI THIÊU - BÌNH DƯƠNG",
    "Quốc lộ 13, P. Lái Thiêu, TP Thuận An, Bình Dương",
    10.9063222,
    106.6361425,
    1
  ],
  [
    "BÌNH ĐỊNH",
    "BƯU CỤC 207 TÂY SƠN",
    "207 Tây Sơn, P.Quang Trung, TP.Quy Nhơn, Tỉnh Bình Định",
    13.7600227,
    109.2017472,
    1
  ],
  [
    "BÌNH ĐỊNH",
    "BƯU CỤC BX QUY NHƠN",
    "VP Phương Trang, Bến Xe Quy Nhơn, p.Ghềnh Ráng, TP. Quy Nhơn",
    13.7532627,
    109.2063641,
    1
  ],
  [
    "BÌNH ĐỊNH",
    "PGD AN NHƠN - BÌNH ĐỊNH",
    "Số 2 Đường Nguyễn Văn Linh, Khối Vĩnh Liêm, P. Bình Định, Thị xã An Nhơn",
    13.8890841,
    109.1186601,
    1
  ],
  [
    "BÌNH THUẬN",
    "BƯU CỤC MŨI NÉ - BT",
    "141  Huỳnh Thúc Kháng, P.Mũi Né, TP.Phan Thiết, Tỉnh Bình Thuận",
    10.942119,
    108.2760139,
    1
  ],
  [
    "BÌNH THUẬN",
    "BƯU CỤC PHAN THIẾT - BT",
    "B1 Võ Văn Kiệt, Phú Thủy, TP.Phan Thiết, Tỉnh Bình Thuận",
    10.9402944,
    108.1030622,
    1
  ],
  [
    "CÀ MAU",
    "BƯU CỤC BẾN XE CÀ MAU",
    "BX Cà Mau, QL 1A, P. 6, TP. Cà Mau, tỉnh Cà Mau",
    9.1753865,
    105.1604918,
    1
  ],
  [
    "CÀ MAU",
    "BƯU CỤC CÀ MAU",
    "221/19A1 Lý Thường Kiệt, P. 6, TP. Cà Mau, tỉnh Cà Mau",
    9.1738436,
    105.155617,
    1
  ],
  [
    "CÀ MAU",
    "BƯU CỤC CÀ MAU",
    "210 Lý Thường Kiệt, P6, Cà Mau Thửa đất số 275, tờ bản đồ số 32, Phường 6, TP. Cà Mau)",
    9.173606,
    105.1890204,
    1
  ],
  [
    "CÀ MAU",
    "BƯU CỤC ĐẦM DƠI - CÀ MAU",
    "Khóm 1, Thị Trấn Đầm Dơi, Huyện Đầm Dơi, tỉnh Cà Mau",
    9.0004432,
    105.1934832,
    1
  ],
  [
    "CÀ MAU",
    "BƯU CỤC NĂM CĂN - CÀ MAU",
    "BX Năm Căn, Khóm Cái Nai, TT.Năm Căn, H.Năm Căn, tỉnh Cà Mau",
    8.7622138,
    104.9986173,
    1
  ],
  [
    "CẦN THƠ",
    "BƯU CỤC 13 PHAN ĐĂNG LƯU",
    "13 Phan Đăng Lưu, P.Thới Bình, Q.Ninh Kiều, Cần Thơ",
    10.044302,
    105.7777037,
    1
  ],
  [
    "CẦN THƠ",
    "BƯU CỤC 91B CẦN THƠ",
    "38C Nguyễn Văn Linh, Phường Hưng Lợi, Quận Ninh Kiều, Thành Phố Cần Thơ",
    10.0242489,
    105.7590757,
    1
  ],
  [
    "CẦN THƠ",
    "BƯU CỤC CÁI RĂNG",
    "BX Khách Trung tâm TP, P.Hưng Thạnh, Q.Cái Răng, Cần Thơ",
    10.0060666,
    105.7694997,
    1
  ],
  [
    "CẦN THƠ",
    "BƯU CỤC Ô MÔN",
    "Khu vực 5, P.Châu Văn Liêm, Q.Ô Môn, Cần Thơ",
    10.1085973,
    105.615931,
    1
  ],
  [
    "CẦN THƠ",
    "BƯU CỤC PHONG ĐIỀN",
    "133 PHAN VĂN TRỊ, TT. PHONG ĐIỀN, H. PHONG ĐIỀN, CẦN THƠ",
    9.9965169,
    105.6624505,
    1
  ],
  [
    "CẦN THƠ",
    "BƯU CỤC THỐT NỐT",
    "Khu vực Qui Thạnh 1, P.Trung Kiên, Q.Thốt Nốt, Cần Thơ",
    10.2497649,
    105.540334,
    1
  ],
  [
    "ĐÀ NẴNG",
    "BƯU CỤC 15 TÚ MỠ - ĐÀ NẴNG",
    "15 Tú Mỡ, Phường Hòa An, Quận Cẩm Lệ, TP. Đà Nẵng",
    16.0531777,
    108.1737321,
    1
  ],
  [
    "ĐÀ NẴNG",
    "BƯU CỤC 16 TRẦN PHÚ Đ.NẴNG",
    "16 Trần Phú, Đà Nẵng Plaza, P Thạch Thang, Q Hải Châu, TP Đà Nẵng",
    16.0794155,
    108.1846131,
    1
  ],
  [
    "ĐÀ NẴNG",
    "BƯU CỤC 17 – 18AH NAM TRÂN ĐÀ NẴNG",
    "Lô 17 - 18AH Nam Trân, P.Hòa Minh, Q.Liên Chiểu, Đà Nẵng",
    16.0593111,
    108.1709661,
    1
  ],
  [
    "ĐÀ NẴNG",
    "BƯU CỤC 861 NGÔ QUYỀN - ĐÀ NẴNG",
    "861 Ngô Quyền, Phường An Hải Đông, Quận Sơn Trà",
    16.065953,
    108.2319192,
    1
  ],
  [
    "ĐÀ NẴNG",
    "BƯU CỤC 94 NGUYỄN TRI PHƯƠNG",
    "74 Nguyễn Tri Phương, P.Chinh Gián, Q.Thanh Khê, TP.Đà Nẵng",
    16.0625002,
    108.2014057,
    1
  ],
  [
    "ĐẮK LẮK",
    "BƯU CỤC ĐẮK LẮK",
    "172 Lê Duẩn , TP Buôn Mê Thuột",
    12.6652162,
    108.0345296,
    1
  ],
  [
    "ĐẮK NÔNG",
    "BƯU CỤC ĐẮK NÔNG",
    "226 Hai Bà Trưng (cây xăng Hồ Vịt), Thị xã Gia Nghĩa, Đăk Nông",
    12.0028435,
    107.6808409,
    1
  ],
  [
    "ĐỒNG NAI",
    "BƯU CỤC 193 ĐỒNG KHỞI",
    "2/18 Khu phố 6 (193 Đồng Khởi), P.Tam Hiệp, TP Biên Hòa",
    10.957418,
    106.8566849,
    1
  ],
  [
    "ĐỒNG NAI",
    "BƯU CỤC BIÊN HÒA",
    "D9, Tổ 2, KP4, XLHN, P.Long Bình, TP. Biên Hòa",
    10.9707444,
    106.7923553,
    1
  ],
  [
    "ĐỒNG THÁP",
    "BƯU CỤC BẾN XE CAO LÃNH",
    "Quốc lộ 30, Ấp An Định, Xã An Bình, Huyện Cao Lãnh, Đồng Tháp",
    10.448450,
    105.671285,
    1
  ],
  [
    "ĐỒNG THÁP",
    "BƯU CỤC CAO LÃNH",
    "17-19 Võ Thị Sáu. Phường 2. Tp Cao Lãnh - Đồng Tháp",
    10.448450,
    105.671285,
    1
  ],
  [
    "ĐỒNG THÁP",
    "BƯU CỤC SA ĐÉC",
    "149/8 Khóm Hòa Khánh, P.2, TP.Sa Đéc, Đồng Tháp",
    10.2886334,
    105.7688894,
    1
  ],
  [
    "HÀ NỘI",
    "BƯU CỤC 839 GIẢI PHÓNG",
    "839 Giải Phóng, P.Giáp Bát, Q.Hoàng Mai, Hà Nội",
    20.9825531,
    105.838772,
    1
  ],
  [
    "HÀ NỘI",
    "BƯU CỤC CẦU GIẤY",
    "467 Nguyễn Khang, P. Yên Hòa, Q. Cầu Giấy, Hà Nội",
    21.023283,
    105.7979442,
    1
  ],
  [
    "HÀ NỘI",
    "BƯU CỤC HÀ NỘI",
    "BX Giáp Bát, đường Giải Phóng, P.Hoàng Liệt, Q.Hoàng Mai",
    20.9795399,
    105.8361944,
    1
  ],
  [
    "HÀ NỘI",
    "BƯU CỤC VĨNH TUY",
    "KCN Vĩnh Tuy, P. Vĩnh Hưng, Q. Hoàng Mai, Hà Nội",
    20.9831638,
    105.8714005,
    1
  ],
  [
    "HẬU GIANG",
    "BƯU CỤC CÁI TẮC",
    "457 QL 1A,TT.Cái Tắc, H.Châu Thành A, Hậu Giang",
    9.9299945,
    105.7228076,
    1
  ],
  [
    "HẬU GIANG",
    "BƯU CỤC NGÃ 7",
    "Đường 3/2, khu vực 5, Phường Ngã 7, Thị Xã Ngã 7, Hậu Giang. (BX mới Ngã 7)",
    9.828089,
    105.808369,
    1
  ],
  [
    "HẬU GIANG",
    "BƯU CỤC VỊ THANH",
    "BX Vị Thanh Quốc Lộ 61C - Đường nối Vị Thanh Cần Thơ, Xã Vị Trung, Huyện Vị Thủy, Hậu Giang",
    9.7821254,
    105.4974922,
    1
  ],
  [
    "HUẾ",
    "BƯU CỤC 64 NGUYỄN TRI PHƯƠNG - HUẾ",
    "64 Nguyễn Tri Phương,  P. Phú Hội, TP.Huế",
    16.465966857446833,
    107.59424978346821,
    1
  ],
  [
    "HUẾ",
    "BƯU CỤC BX PHÍA BẮC HUẾ",
    "132 Lý Thái Tổ, P.An Hòa, TP Huế",
    16.4860105,
    107.5083516,
    1
  ],
  [
    "HUẾ",
    "BƯU CỤC BX PHÍA NAM HUẾ",
    "97 An Dương Vương, P. An Đông, TP. Huế",
    16.4505376,
    107.5709283,
    1
  ],
  [
    "KIÊN GIANG",
    "BƯU CỤC LẠC HỒNG",
    "65  Lạc Hồng, KP2, P.Vĩnh Lạc, TP.Rạch Giá",
    9.9981223,
    105.0915896,
    1
  ],
  [
    "KIÊN GIANG",
    "BƯU CỤC PHAN THỊ RÀNG",
    "L6–03 Phan Thị Ràng, P. An Hòa, TP. Rạch Giá, Kiên Giang",
    9.9686571,
    105.1016238,
    1
  ],
  [
    "KIÊN GIANG",
    "BƯU CỤC RẠCH GIÁ",
    "260A Nguyễn Bỉnh Khiêm, P.Vĩnh Quang, TP.Rạch Giá, Kiên Giang",
    10.0211538,
    105.0708803,
    1
  ],
  [
    "KIÊN GIANG",
    "BƯU CỤC RẠCH SỎI",
    "BX Kiên Giang, X.Vĩnh Hòa Hiệp, H.Châu Thành, Kiên Giang",
    9.9447851,
    105.1265598,
    1
  ],
  [
    "KHÁNH HÒA",
    "BƯU CỤC 14 NGUYỄN ĐỨC CẢNH - NHA TRANG",
    "14 Nguyễn Đức Cảnh, phường Phước Long, Nha Trang",
    12.2162682,
    109.1916768,
    1
  ],
  [
    "KHÁNH HÒA",
    "BƯU CỤC 151 NTMK - NHA TRANG",
    "151 Nguyễn Thị Minh Khai, Phường Phước Hòa",
    12.2356147,
    109.1835978,
    1
  ],
  [
    "KHÁNH HÒA",
    "BƯU CỤC 168 NGUYỄN XIỂN - NHA TRANG",
    "168 Nguyễn Xiển, Tổ 5, Thôn Liên Thành , Xã Vĩnh Phương",
    12.303605,
    109.1697767,
    1
  ],
  [
    "KHÁNH HÒA",
    "BƯU CỤC 176 TRẦN QUÝ CÁP - NHA TRANG",
    "176 Trần Quý Cáp, TP.Nha Trang",
    12.2516328,
    109.1683659,
    1
  ],
  [
    "KHÁNH HÒA",
    "BƯU CỤC BX CAM RANH A",
    "BX Cam Ranh, 01 Lê Duẩn, P.Cam Lộc, TP.Cam Ranh",
    11.9195215,
    109.1445072,
    1
  ],
  [
    "KHÁNH HÒA",
    "BƯU CỤC BX NINH HÒA",
    "Quốc Lộ 1A, Km 1421, Tổ Dân phố Thanh Châu, P.Ninh Giang, TX Ninh Hòa,, Tỉnh Khánh Hòa",
    12.4769956,
    109.1267661,
    1
  ],
  [
    "KHÁNH HÒA",
    "BƯU CỤC BX PHÍA BẮC NHA TRANG",
    "Số 1 Đường 2/4, P.Vĩnh Hòa, Nha Trang(nằm trong BX Phía Bắc Nha Trang)",
    12.2885428,
    109.1880267,
    1
  ],
  [
    "KHÁNH HÒA",
    "BƯU CỤC DIÊN KHÁNH",
    "62 Lạc Long Quân, TT.Diên Khánh, H.Diên Khánh",
    12.2572158,
    109.0920058,
    1
  ],
  [
    "KHÁNH HÒA",
    "BƯU CỤC MỸ CA",
    "240 Đại lộ Hùng Vương, phường Cam Nghĩa, Tp.Cam Ranh, Khánh Hoà",
    11.988826542347164,
    109.19184675753446,
    1
  ],
  [
    "Hồ Chí Minh",
    "BƯU CỤC 186A NGUYỄN ẢNH THỦ",
    "186A Nguyễn Ảnh Thủ, Phường Hiệp Thành, Q.12, HCM",
    10.877052,
    106.6402715,
    1
  ],
  [
    "Hồ Chí Minh",
    "BƯU CỤC 215A BỜ BAO TÂN THẮNG",
    "215A Bờ Bao Tân Thắng, Phường Sơn Kỳ, Quận Tân Phú. HCM",
    10.7985892,
    106.6113697,
    1
  ],
  [
    "Hồ Chí Minh",
    "BƯU CỤC 223 PHẠM HỮU LẦU",
    "223 Phạm Hữu Lầu, Phú Mỹ, Quận 7, HCM",
    10.7042113,
    106.7278382,
    1
  ],
  [
    "Hồ Chí Minh",
    "BƯU CỤC 241 LÊ HỒNG PHONG",
    "241 - 249B LÊ HỒNG PHONG, PHƯỜNG 4, QUẬN 5 ,HCM",
    10.7598082,
    106.6747322,
    1
  ],
  [
    "Hồ Chí Minh",
    "BƯU CỤC 288 ĐỒNG ĐEN",
    "288 Đồng Đen, P.10, Q.Tân Bình, HCM",
    10.7855571,
    106.6402984,
    1
  ],
  [
    "Hồ Chí Minh",
    "BƯU CỤC 319 PHẠM NGŨ LÃO",
    "319 Phạm Ngũ Lão, P. Phạm Ngũ Lão, Q.1",
    10.7674786,
    106.6881638,
    1
  ],
  [
    "Hồ Chí Minh",
    "BƯU CỤC 335 LÊ HỒNG PHONG",
    "335-337 Lê Hồng Phong, P.2, Q.10, TP.HCM",
    10.7747351,
    106.6623139,
    1
  ],
  [
    "Hồ Chí Minh",
    "BƯU CỤC 358 NGUYỄN VĂN LƯỢNG",
    "358 Nguyễn Văn Lượng, Phường 16, Quận Gò Vấp, HCM",
    10.8387409,
    106.6652374,
    1
  ],
  [
    "Hồ Chí Minh",
    "BƯU CỤC 367 ĐINH BỘ LĨNH",
    "367 Đinh Bộ Lĩnh, Phường 26, Quận Bình Thạnh",
    10.815295,
    106.7078167,
    1
  ],
  [
    "Hồ Chí Minh",
    "BƯU CỤC 486A LÊ VĂN LƯƠNG",
    "486A Lê Văn Lương, P. Tân Phong, Q.7, HCM",
    10.7351687,
    106.6998548,
    1
  ],
  [
    "Hồ Chí Minh",
    "BƯU CỤC 51A PHAN ĐĂNG LƯU",
    "51A Phan Đăng Lưu, Phường 7, Quận Phú Nhuận, HCM",
    10.8033977,
    106.6869716,
    1
  ],
  [
    "Hồ Chí Minh",
    "BƯU CỤC 973 LŨY BÁN BÍCH",
    "973 LŨY BÁN BÍCH, P. TÂN THÀNH, TÂN PHÚ, HCM",
    10.792504,
    106.6349632,
    1
  ],
  [
    "Hồ Chí Minh",
    "BƯU CỤC BẾN XE NGÃ TƯ GA",
    "720 quốc lộ 1A, phường Thạnh Lộc, quận 12, HCM",
    10.8692239,
    106.650881,
    1
  ],
  [
    "Hồ Chí Minh",
    "BƯU CỤC BX AN SƯƠNG",
    "Bến Xe An Sương, QL 22, Bà Điểm, Hóc Môn, TP.HCM",
    10.8444242,
    106.6100214,
    1
  ],
  [
    "Hồ Chí Minh",
    "BƯU CỤC BX MIỀN ĐÔNG",
    "292 Đinh Bộ Lĩnh, P.26, Q.Bình Thạnh, TP.HCM",
    10.8146279,
    106.7080328,
    1
  ],
  [
    "Hồ Chí Minh",
    "BƯU CỤC BX MIỀN TÂY",
    "395 Kinh Dương Vương. P. An Lạc A. Quận Bình Tân - Bãi trả khách",
    10.7406653,
    106.6132549,
    1
  ],
  [
    "Hồ Chí Minh",
    "BƯU CỤC BXMĐ (MỚI)",
    "501 đường Hoàng Hữu Nam, phường Long Bình, Thành phố Thủ Đức",
    10.8546666,
    106.7157521,
    1
  ],
  [
    "Hồ Chí Minh",
    "BƯU CỤC ĐH BÁCH KHOA",
    "6B Đường số 02 Cư Xá Lữ Gia, Phường 15, Quận 11, HCM",
    10.7723109,
    106.6543853,
    1
  ],
  [
    "Hồ Chí Minh",
    "BƯU CỤC HÀNG XANH",
    "486H - 486J Điện Biên Phủ, Phường 21, Quận Bình Thạnh, TP. HCM",
    10.8010127,
    106.7074942,
    1
  ],
  [
    "Hồ Chí Minh",
    "BƯU CỤC NGÃ 4 BÌNH PHƯỚC",
    "Số 136, Quốc lộ 1A, KP4, Tam Bình, Thủ Đức, TP.HCM",
    10.8673286,
    106.7260825,
    1
  ],
  [
    "Hồ Chí Minh",
    "BƯU CỤC XA LỘ HÀ NỘI",
    "800  Đường QL 52, KP 3, Phường Hiệp Phú, Quận 9, Tp. HCM",
    10.8508795,
    106.767294,
    1
  ],
  [
    "LÂM ĐỒNG",
    "BƯU CỤC BẢO LÂM - LÂM ĐỒNG",
    "95 Trần Phú -TT Lộc Thắng -Huyện Bảo Lâm-Tỉnh Lâm Đồng",
    11.6317737,
    107.8343966,
    1
  ],
  [
    "LÂM ĐỒNG",
    "BƯU CỤC BẢO LỘC - LÂM ĐỒNG",
    "399 Trần Phú P.Lộc Sơn, TP.Bảo Lộc, Tỉnh Lâm Đồng",
    11.5366042,
    107.8122879,
    1
  ],
  [
    "LÂM ĐỒNG",
    "BƯU CỤC BẾN XE ĐÀ LẠT",
    "Số 1 Tô Hiến Thành. Phường 3. TP Đà lạt. Tỉnh Lâm Đồng",
    11.9264194,
    108.4434422,
    1
  ],
  [
    "LÂM ĐỒNG",
    "BƯU CỤC DI LINH",
    "Bến xe Di Linh, Đường Hùng Vương, Thị Trấn Di Linh, Tỉnh Lâm Đồng",
    11.5904234,
    108.0732091,
    1
  ],
  [
    "LÂM ĐỒNG",
    "BƯU CỤC ĐỨC TRỌNG",
    "795 Quốc Lộ 20,thị trấn Liên nghĩa,Huyện Đức Trọng,Tỉnh Lâm Đồng",
    11.7239716,
    108.3577151,
    1
  ],
  [
    "LÂM ĐỒNG",
    "BƯU CỤC LANGBIANG - LÂM ĐỒNG",
    "Số 03 LangBiang, Thị trấn Lạc Dương, Huyện Lạc Dương, Tỉnh Lâm Đồng",
    12.0140372,
    108.4200275,
    1
  ],
  [
    "LÂM ĐỒNG",
    "BƯU CỤC LÊ QUÝ ĐÔN - ĐÀ LẠT",
    "11A/2 Lê Quý Đôn, P.5, TP.Đà Lạt, Tỉnh Lâm Đồng",
    11.9412629,
    108.4286641,
    1
  ],
  [
    "LÂM ĐỒNG",
    "BƯU CỤC NGUYỄN CÔNG TRỨ ĐÀ LẠT",
    "02 Nguyễn Công Trứ, Phường 2, TP. Đà Lạt, Tỉnh Lâm Đồng",
    11.9484987,
    108.4222033,
    1
  ],
  [
    "LÂM ĐỒNG",
    "BƯU CỤC THẠNH MỸ",
    "Số 44, Đường 2/4, Khu phố Nghĩa Đức, TT. Thạnh Mỹ, H. Đơn Dương, Tỉnh Lâm Đồng",
    11.7622545,
    108.5006016,
    1
  ],
  [
    "LÂM ĐỒNG",
    "BƯU CỤC TRẠI MÁT - ĐÀ LẠT",
    "Số 07 Tự Phước, Phường 11, TP. Đà Lạt, Tỉnh Lâm Đồng",
    11.944475,
    108.498796,
    1
  ],
  [
    "NAM ĐỊNH",
    "BƯU CỤC NAM ĐỊNH",
    "Bến xe khách Nam Định, KM2, Đường Điện Biên, Phường Lộc Hòa, TP. Nam Định",
    20.433614,
    106.1274401,
    1
  ],
  [
    "NINH THUẬN",
    "BƯU CỤC BX PHAN RANG",
    "BX khách Ninh Thuận, Đường Lê Duẩn, Đài Sơn, Phan Rang - Tháp Chàm",
    11.5849143,
    108.9849008,
    1
  ],
  [
    "NINH THUẬN",
    "BƯU CỤC PHÚ QUÝ - NINH THUẬN",
    "Số 118 Đường QL1A, Thị Trấn Phước Dân, Tỉnh Ninh Thuận",
    11.5235303,
    108.9240998,
    1
  ],
  [
    "PHÚ YÊN",
    "BƯU CỤC 77 LÊ LỢI",
    "77 Lê Lợi, P.3, TP.Tuy Hòa, Phú Yên",
    13.0875194,
    109.2991399,
    1
  ],
  [
    "PHÚ YÊN",
    "BƯU CỤC BX PHÍA NAM PHÚ YÊN",
    "507 Nguyễn Văn Linh, P.Phú Lâm, TP.Tuy Hòa",
    13.0407141,
    109.3092346,
    1
  ],
  [
    "QUẢNG NAM",
    "BƯU CỤC NAM PHƯỚC - QUẢNG NAM",
    "BX Nam Phước, TT.Nam Phước, H.Duy Xuyên",
    15.8385768,
    108.2817195,
    1
  ],
  [
    "QUẢNG NAM",
    "BƯU CỤC TAM KỲ - QUẢNG NAM",
    "252 Nguyễn Hoàng, Phường An Sơn, TP.Tam Kỳ",
    15.5555515,
    108.4865288,
    1
  ],
  [
    "QUẢNG NGÃI",
    "BƯU CỤC QUẢNG NGÃI",
    "2 Trần Khánh Dư, P.Nghĩa Chánh, TP Quảng Ngãi, Tỉnh Quảng Ngãi",
    15.1149374,
    108.8093541,
    1
  ],
  [
    "SÓC TRĂNG",
    "BƯU CỤC AN TRẠCH",
    "720 QL1A ấp An Trạch, xã An Hiệp, huyện Châu Thành, tỉnh Sóc Trăng",
    9.6510436,
    105.9361829,
    1
  ],
  [
    "SÓC TRĂNG",
    "BƯU CỤC NGÃ NĂM",
    "Bến Xe Ngã Năm, Số 76 Đường Nguyễn Trãi, Khóm 3, Phường 1, TX Ngã Năm, tỉnh Sóc Trăng",
    9.5604027,
    105.606969,
    1
  ],
  [
    "SÓC TRĂNG",
    "BƯU CỤC SÓC TRĂNG",
    "38 Lê Duẩn, P.3, TP.Sóc Trăng, tỉnh Sóc Trăng",
    9.594357,
    105.9716287,
    1
  ],
  [
    "TIỀN GIANG",
    "BƯU CỤC MỸ THO",
    "212 Trần Hưng Đạo, Phường 4, TP Mỹ Tho, tỉnh Tiền Giang",
    10.3560386,
    106.3221707,
    1
  ],
  [
    "TIỀN GIANG",
    "BƯU CỤC SA TRA",
    "Ấp Hòa Phúc, X.Hòa Khánh, H.Cái Bè, tỉnh Tiền Giang",
    10.3590366,
    105.8395245,
    1
  ],
  [
    "TIỀN GIANG",
    "BƯU CỤC THÂN CỬU NGHĨA - TIỀN GIANG",
    "Đường tỉnh 878,  Ấp 1, Xã Tam Hiệp, Huyện Châu Thành, Tỉnh Tiền Giang ( Cây xăng 19  Thân Cửu Nghĩa)",
    10.4240354,
    106.3167177,
    1
  ],
  [
    "TRÀ VINH",
    "BƯU CỤC BẾN XE TRÀ VINH",
    "559 QL54, Khóm 4, P.9, TP.Trà Vinh, tỉnh Trà Vinh",
    9.891256,
    106.3020377,
    1
  ],
  [
    "TRÀ VINH",
    "BƯU CỤC BÌNH PHÚ",
    "Ấp Nguyệt Lãng A, X.Bình Phú, H.Càng Long, tỉnh Trà Vinh",
    9.9630309,
    106.2413939,
    1
  ],
  [
    "TRÀ VINH",
    "BƯU CỤC BX DUYÊN HẢI - TRÀ VINH",
    "đường 19 tháng 5, khóm 1, phường 1, thị xã Duyên Hải, Trà Vinh",
    9.6346434,
    106.4912174,
    1
  ],
  [
    "TRÀ VINH",
    "BƯU CỤC TRÀ VINH",
    "27 Nguyễn Đáng, Khóm 1, P.7, TP.Trà Vinh, tỉnh Trà Vinh",
    9.9259058,
    106.3320948,
    1
  ],
  [
    "VĨNH LONG",
    "BƯU CỤC BÌNH MINH",
    "Ấp Thuận Tiến B, X.Thuận An, TX.Bình Minh, Vĩnh Long",
    10.0752712,
    105.8389778,
    1
  ],
  [
    "VĨNH LONG",
    "BƯU CỤC BX VĨNH LONG",
    "1E Đinh Tiên Hoàng, P.8, TP.Vĩnh Long",
    10.2384081,
    105.954894,
    1
  ],
  [
    "VĨNH LONG",
    "BƯU CỤC SONG PHÚ",
    "Lô A27-29, Song Phú mới, Ấp Phú Ninh, X.Song Phú, H.Tam Bình, Vĩnh Long",
    10.117544414982738,
    105.90160202084256,
    1
  ],
  [
    "VĨNH LONG",
    "BƯU CỤC TRÀ ÔN",
    "Bến xe Trà Ôn, Tổ 6, Khu 7, Thị Trấn Trà Ôn, Huyện Trà Ôn, Tỉnh Vĩnh Long.",
    9.9705978,
    105.9221828,
    1
  ]
];

async function initMap() {
  const position = { lat: 16.789516, lng: 106.583847 }; // Quang Tri - Center of VN
  const { Map, InfoWindow } = await google.maps.importLibrary("maps");
  const { AdvancedMarkerElement, PinElement } = await google.maps.importLibrary("marker");

  // The map, Quang Tri - Center of VN
  map = new Map(document.getElementById("map"), {
    zoom: 6,
    center: position,
    mapId: "7ba16be0c9375fa7",
  });

  const featureLayer = map.getFeatureLayer(
    google.maps.FeatureType.ADMINISTRATIVE_AREA_LEVEL_1,
  );

  featureLayer.style = (featureStyleFunctionOptions) => {
    const placeFeature = featureStyleFunctionOptions.feature;
    const population = provinces[placeFeature.placeId];
    let fillColor, fillOpacity;

    if (population > 0) {
      fillColor = "#ef5222"; // Futa color
      fillOpacity =  0.5;
    } else if (population == 0) {
      fillColor = "green"; 
      fillOpacity =  0.4;
    }

    return {
      fillColor,
      fillOpacity,
    };
  };

  const infoWindow = new InfoWindow();

  for (let i = 0; i < post_offices.length; i++) {
    const pin = new PinElement({
      glyph: `${i + 1}`,
      scale: 1.5,
    });

    const marker = new AdvancedMarkerElement({
      map: map,
      position: { lat: post_offices[i][3], lng: post_offices[i][4] },
      // title: post_offices[i][1],
      gmpClickable: true
    });

    marker.addListener("click", ({ domEvent, latLng }) => {
      // const { target } = domEvent;
      const content = `
      <div style="padding: 8px">
        <h2 style="margin-top: 0">${post_offices[i][0]}</h2>
        <h3>${post_offices[i][1]}</h3>
        <p>${post_offices[i][2]}</p>
      </div>
    `;

      infoWindow.close();
      infoWindow.setContent(content);
      infoWindow.open(marker.map, marker);
    });

  }
}

initMap();
